export default {
  namespaced: true,

  state: {
    company: {},
    defaults: {},
  },

  getters: {},

  mutations: {
    set(state, payload) {
      state.company = payload;
    },
    setDefaults(state, payload) {
      state.defaults = payload;
    },
  },

  actions: {
    set({ commit }, payload) {
      commit('set', payload);
    },

    setDefaults({ commit }, payload) {
      commit('setDefaults', payload);
    },
  },
};
